/* istanbul ignore file */
export * from './SeoElement';
